import axios from "axios";
import { API_URL } from "../constants";

export const fetch = (companyId, params = {}) => {
  const url = `${API_URL}/${companyId}/customers/finance/pending-approvals`;
  return axios.get(url, { params }).then((response) => response.data);
};
